import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import CouponView from 'components/layout/order/CouponView';

class CouponDetails extends React.Component {
  render() {
    const {
      intl: { messages },
      appIntl,
      match,
    } = this.props;

    const crumbs = [
      { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
      { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
      { link: appIntl.urlPrefix + 'account/settings/coupons', name: messages.coupons },
    ];

    return <CouponView couponId={match.params.couponId} crumbs={crumbs} />;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(CouponDetails));
